import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IC_FILTER_GREEN } from '@common/Assets/images';
import Image from 'next/image';
import DropdownControl from '@common/Component/Forms/Dropdown/Dropdown';

import { useRouter } from 'next/router';
import { capitalizeFirstLetter } from '@common/Utility/common-utils';
import { ONLINE_PHARMACY_BRAND_ROUTE } from '@common/Utility/constants';
import { isRTL, useTranslation } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../i18n';

const SearchTitleBar = (props) => {
  const t = useTranslation();
  const router = useRouter();
  const [currentLang, setCurrentLanguage] = useState('');

  let searchTitle = '';
  if (props?.searchedFor?.length > 0) {
    searchTitle += t('Search.resultFor') + " ";
  }
  let searchSubTitle = '';
  if (props?.facetResponse?.totalItems !== 0) {
    searchSubTitle = props?.facetResponse?.totalItems === 1 
      ? t('EpharmacyFilter.foundXResult', {value: props?.facetResponse?.totalItems})
      : t('EpharmacyFilter.foundXResults', {value: props?.facetResponse?.totalItems})
  }

  const filterUndefinedFromArray = (array) => {
    const allSearchTerms = [...array].filter((el) => {
      return el !== '' && el !== null && typeof el !== 'undefined' && el !== 'NaN';
    });
    return Array.from(new Set(allSearchTerms));
  };

  useEffect(() => {
    if(window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);
  
  return (
    <>
    {props?.facetResponse?.message && props?.facetResponse?.oosData ? (
      <div className="oosMessage" dangerouslySetInnerHTML={{ __html: props?.facetResponse?.message }}></div>
    ) : 
    <div className="titleBar">
      {!props?.facetResponse?.message && (
      <h2 className={`title ${props?.searchedFor?.length > 0 ? 'notruncet' : ''}`}>
        {!props?.loadingList && props?.checkFilterApplied && typeof window !== 'undefined' && (
          <>
            <span 
              className={`resultText`} 
              title={filterUndefinedFromArray(props?.searchedFor)?.join(', ')}
              >
              <span
                className="label"
                style={{
                  margin: currentLang && !isRTL(currentLang) ? '0 5px 0 0' : '0 0 0 5px',
                }}  
              >{searchTitle || ''}</span>
              <h1 className="searchedText">
                {(() => {
                  return props?.searchedFor?.length > 0
                    ? filterUndefinedFromArray(props?.searchedFor)?.join(', ')
                    : router?.pathname?.includes(ONLINE_PHARMACY_BRAND_ROUTE) ? capitalizeFirstLetter(`${router?.pathname.split('brand/')?.[1].split('/')?.[0]}`) : t('Search.allCategories');
                })()}
              </h1>
            </span>{' '}
          </>
        )}
        {searchSubTitle !== '' && props?.checkFilterApplied && (
          <div className="subTitle">{!props?.loadingList ? searchSubTitle : ''}</div>
        )}
      </h2>
      )}
      {!props?.facetResponse?.oosData && (
      <div className="dropDownContent">
        {!props?.loadingList && props?.checkFilterApplied && (
          <>
            <span className="label">{props?.checkFilterApplied ? t('Search.txtSortBy') : null}</span>
            <DropdownControl
              data={{ values: props?.sortFilterOptions?.map((item) => item?.displayName) }}
              caption={props?.checkFilterApplied ? props?.sortBy?.displayName : null}
              handleSelect={props?.onSortBy}
            />
          </>
        )}
        <div className="noDesktop showFilter" onClick={() => props?.setIsOpen(true)}>
          <Image src={IC_FILTER_GREEN} alt="" layout="fill" />
        </div>
      </div>
      )}
    </div>
    }
    </>
  );
};

SearchTitleBar.propTypes = {
  setIsOpen: PropTypes.func,
  sortFilterOptions: PropTypes.any,
  onSortBy: PropTypes.any,
  sortBy: PropTypes.any,
  facetResponse: PropTypes.any,
  loadingList: PropTypes.any,
  checkFilterApplied: PropTypes.any,
  searchedFor: PropTypes.any,
};

export default SearchTitleBar;
